






import { Component, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import Slide from '@/types/Slide';
import Scenarios from '@/types/Scenarios';
import BaseComponent from '../BaseComponent.vue';
import TrainingNav from '@/components/TrainingNav.vue';
import { Fragment } from 'vue-fragment';
const AppState = getModule(AppModule, store);

@Component({ components: { Fragment, TrainingNav } })
export default class Scenario extends BaseComponent {
  slides: Slide[] = AppState.tableOfContents.slides || {};
  scenarios: Scenarios = AppState.tableOfContents.scenarios || {};
  @Prop() folderSrc!: string
  @Prop() firstPage!: string
  @Prop() lastPage!: string

  created(){
    AppState.setCurrentScenarioPage(this.firstPage);
    this.saveData({});
  }

  get pageToRender(){
    const currentScenarioPage = AppState.currentScenarioPage;
    
    if(currentScenarioPage === this.lastPage || AppState.getBiggestIndex > AppState.currentIndex)
      AppState.setIsScenarioPageActive(false); 
    else
      AppState.setIsScenarioPageActive(true); 
    
    const index = this.scenarios[this.folderSrc].findIndex((item) => item.pageName === currentScenarioPage);
    return this.scenarios[this.folderSrc][index].id;
  }

  get isScenarioPageActive(){
    return AppState.isScenarioPageActive;
  }
  
  get isBackwardsDisabled(): boolean {
    return AppState.currentSlide === this.slides[0].id || false;
  }

  previous() {
    AppState.increment(-1);
    AppState.setIsScenarioPageActive(false); 
  }
}
